import { checkIsStringEmpty } from "../dataTypes/string";
import { INDIA_COUNTRY_DATA } from "./countriesData";

export const getCountryIsIndia = (str: string = ""): boolean =>
    !checkIsStringEmpty(str) &&
    typeof str === "string" &&
    str.toLowerCase() === INDIA_COUNTRY_DATA.name.toLowerCase();
